<script>
import { VImg } from 'vuetify/lib/components/VImg';

// eslint-disable-next-line vue/require-direct-export
export default VImg;
</script>
